import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const app = initializeApp({
  apiKey: 'AIzaSyBYwIBUGDQC0TqXeaJc7g4oV_LrId2f1sA',
  authDomain: 'prs-images.firebaseapp.com',
  projectId: 'prs-images',
  storageBucket: 'prs-images.firebasestorage.app',
  messagingSenderId: '5699509210',
  appId: '1:5699509210:web:6b5f7d4425934c9d83fee3'
});

const storage = getStorage(app);
export default storage;
